import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../../components/info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

export default function CreditCard({
  inputText,
  cardIcon,
  cardText,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {!data?.default_source && (
        <Menu.Item
          key="0"
          onClick={() => dispatch(UserAction.setCardDefaultReq(data.id))}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Set as default</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
              info(
                "error",
                "Cannot delete default card! Make any other card your default and then delete this card"
              );
            }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify={fromOrder ? "space-between" : "center"}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
        <Card className="ant-card-body" style={cardStyle}>
          <Row justify="start">
            <Col>
              {tickIcon && (
                <BiCheckDouble
                  color="lightblue"
                  size={25}
                  style={{
                    visibility: !data?.default_source ? "hidden" : "visible",
                  }}
                />
              )}
            </Col>
          </Row>
          <Row justify={"space-between"}>
            {paidText && <Col style={{ margin: "8px" }}>Paid Via</Col>}

            <Col
              xs={5}
              sm={2}
              md={6}
              lg={6}
              xl={6}
              style={{
                margin: shipVisaStyling ? "8px -35px 0px 10px" : "0px 0px 0px 10px",
                height: "28px",
                backgroundImage: !shipVisaStyling && `url(${Chip}) `,
                width: "28px",
                maxHeight: "28px",
                backgroundRepeat: "no-repeat",
                justifyContent: "end",
              }}
            >
              {shipVisaStyling && <img src={Chip} />}
            </Col>
            <Col
              xs={9}
              sm={3}
              md={8}
              lg={8}
              xl={14}
              style={{
                margin: shipVisaStyling ? "8px -7px 0px 10px" : "0px -22px 0px 0px",
                height: "30px",
                backgroundImage: `url(${straightVisaCard}) `,
                width: "51px",
                display: "inline-block",
                position: "relative",
                backgroundPosition:
                  data?.source?.brand === "MasterCard"
                    ? "0px -158px"
                    : data?.source?.brand === "American Express"
                      ? "0 -240px"
                      : data?.source?.brand === "Discover"
                        ? "0 -400px"
                        : data?.source?.brand === "Diners Club"
                          ? "0 -480px"
                          : data?.source?.brand === "JCB"
                            ? "0 -320px"
                            : data?.source?.brand === "UnionPay"
                              ? "0 0px"
                              : "0 -74px",
                backgroundRepeat: "no-repeat",
              }}
            ></Col>
            <Col xs={8} sm={4} md={10} lg={10} xl={4}>
              {dotsIcon && (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  style={{ width: "40%" }}
                >
                  <BsThreeDotsVertical
                    className="pointer-cursor"
                  />
                </Dropdown>
              )}
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={8} md={18} lg={22} xl={24}>
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "18px",
                  margin: "16px 0",
                }}
              >
                {`**** **** **** ${data?.source?.last4 || 4242}`}
              </h5>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col xl={12} lg={12} md={12} sm={2} xs={2} style={{ marginTop: "-10px", padding: '2px' }}>
              <span className="card-countryName">
                {data?.source?.country || "US"}
              </span>
              <span className="card-country">COUNTRY</span>
            </Col>
            <Col
              xs={10}
              sm={8}
              md={12}
              lg={12}
              xl={6}
              style={{ marginTop: "-10px", padding: '2px' }}
            >
              <span className="card-expiryDate text-left">{`${data?.source?.exp_month || 12
                }/${data?.source?.exp_year || 2023}`}</span>
              <span className="card-expiry  text-left">EXP</span>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(data.id, () => setOpenModal(false))
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
